import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, CheckSquareIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  title: 'eBook Completo "Código Hormonal 40+"',
  description: '6 capítulos de ciencia hormonal en lenguaje claro y práctico. El mapa completo de tu nueva biología.',
  value: '$37',
  borderColor: 'border-[#2D5A34]'
}, {
  icon: CalendarIcon,
  title: 'Protocolo de 21 Días',
  description: 'Plan día a día con menú completo, horarios exactos y checklists de seguimiento semanal.',
  value: '$27',
  borderColor: 'border-[#C2856A]'
}, {
  icon: CheckSquareIcon,
  title: 'Checklists y Worksheets',
  description: '7 herramientas de seguimiento listas para imprimir. Tu diario hormonal personal.',
  value: '$17',
  borderColor: 'border-[#C9A84C]'
}];
const CHECKOUT_URL = 'https://www.upreferr.com/cart/44596916224135:1';
export function WhatYouGet() {
  const goToCheckout = () => {
    window.location.href = CHECKOUT_URL;
  };
  return <section className="py-20 lg:py-32 bg-[#FDFAF6]" data-id="element-222">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-223">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-224">
          <h2 className="text-4xl lg:text-5xl font-bold text-[#2D5A34] text-center mb-4" data-id="element-225">
            Todo lo que incluye tu protocolo
          </h2>
          <p className="text-[#C2856A] text-xl font-semibold text-center mb-12" data-id="element-226">
            Valor total: $81 — Tuyo hoy por solo $8.49
          </p>

          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-12" data-id="element-227">
            {items.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: i * 0.1
          }} className={`bg-white rounded-xl p-6 border-t-4 ${item.borderColor} shadow-sm`} data-id="element-228">
                <item.icon className="w-10 h-10 text-[#2D5A34] mb-4" data-id="element-229" />
                <h3 className="text-xl font-bold text-[#2D2D2D] mb-3" data-id="element-230">
                  {item.title}
                </h3>
                <p className="text-[#2D2D2D] mb-4" data-id="element-231">{item.description}</p>
                <p className="text-sm font-semibold text-gray-600" data-id="element-232">
                  Valor: {item.value} |{' '}
                  <span className="text-[#2D5A34]" data-id="element-233">INCLUIDO</span>
                </p>
              </motion.div>)}
          </div>

          <div className="bg-[#C9A84C] rounded-2xl p-6 lg:p-8 max-w-2xl mx-auto text-center mb-8" data-id="element-234">
            <p className="text-2xl lg:text-3xl font-bold text-black mb-2" data-id="element-235">
              Valor total: <span className="line-through opacity-60" data-id="element-236">$81</span>{' '}
              → Tu inversión hoy: $8.49 USD
            </p>
            <p className="text-sm text-black/70" data-id="element-237">
              Precio de lanzamiento por tiempo limitado
            </p>
          </div>

          <div className="text-center" data-id="element-238">
            <p className="text-[#C2856A] text-sm font-semibold mb-4" data-id="element-239">
              ⏰ Precio de lanzamiento — Sube a $27 pronto
            </p>
            <button id="offer-cta" onClick={goToCheckout} className="w-full lg:w-auto bg-[#C9A84C] text-[#1A1A1A] px-10 py-5 rounded-full text-lg font-bold uppercase hover:brightness-110 transition-all shadow-lg mb-4 inline-block" data-id="element-240">
              QUIERO MI PROTOCOLO POR $8.49 →
            </button>
            <p className="text-sm text-[#2D2D2D]" data-id="element-241">
              🔒 Pago seguro via Shopify · PDF descargable inmediatamente ·
              Disponible en cualquier dispositivo
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}